import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import NormalStyle from './Normal.style';

function Normal(props) {
  const { children, indent = false } = props;
  const extraStyles = {};
  if (indent) {
    extraStyles.textIndent = '4pt';
  }
  return (
    <View style={{ ...NormalStyle.container, ...extraStyles }}>
      <Text style={NormalStyle.normal}>{children}</Text>
    </View>
  );
}
export default Normal;
